import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import { resetState, sendEmailConfirmation } from "../../Redux/EmailConfirmation/sendEmailConfirmationSlice";
import { useSendEmailConfirmationMutation } from "../../Redux/EmailConfirmation/sendEmailConfirmationSlice";
import { RootState, AppDispatch, getAppWorkflowState } from "../../Redux/store";
import { FoundationsInput } from "../../GenericComponents/input";
import { FoundationsButton } from "../../GenericComponents/button";
import { useTitleContext } from "../../Hooks/useTitleContext";
import parse from "html-react-parser";
import { useForm } from "react-hook-form";
import { appWorkflowStates } from "../../Types/appWorkflowStates";
import PageNotAccessibleIfLoggedIn from "../ResetPassword/PageNotAcessibleIfLoggedIn";
import { FormValidation } from "../../FormValidationsRules";
import SendEmailConfirmationSuccess from "./sendEmailConfirmationSuccess";
import { FoundationsForm } from "../../GenericComponents/form";

const SendEmailConfirmation: React.FC = () => {

	const [sendEmailConfirmation, { data, error, isLoading }] = useSendEmailConfirmationMutation();
	const appWorkflowState = useSelector((state: RootState) => getAppWorkflowState(state))

	const [emailAddress, setEmailAddress] = useState('')
	const [statusMessage, setStatusMessage] = useState<string | null>(null);
	const [isSuccess, setIsSuccess] = useState(false);

	const { setTitle } = useTitleContext();
	setTitle("Confirmation");

	const {
		register,
		formState: { errors },
		handleSubmit,
		reset,
	} = useForm();

	const handleRetry = () => {
		setEmailAddress("");
		setStatusMessage(null);
		setIsSuccess(false);
		reset();
	}

	useEffect(() => {
		if (!isSuccess) {
			reset();
			setEmailAddress("");
			setStatusMessage(null);
			setIsSuccess(false);
		}
	}, [isSuccess, reset]);

	const onSubmit = async () => {
		if (!emailAddress.trim()) return;
	
		setStatusMessage("");
	
		try {
			const response: any = await sendEmailConfirmation({ email: emailAddress }).unwrap();
	
			if (response?.data?.MessageResults?.length > 0) {
				let success = false;
				let message = "";
	
				for (let i = 0; i < response.data.MessageResults.length; i++) {
					const messageItem = response.data.MessageResults[i];
	
					if (messageItem.HelpMessage === 0) {
						success = true;
					}
					if (response.statusCode === 400) {
						message = messageItem.Message;
					}
				}
				setStatusMessage(message);
				if (success) {
					setIsSuccess(true);
				}
			} else {
				setStatusMessage("Something went wrong. Please try again.");
			}
		} catch (error: any) {
			console.error("API Call Failed:", error);
			setStatusMessage("Failed to send email. Please try again.");
		}
	};
	
	if (appWorkflowState !== appWorkflowStates.UNAUTHENTICATED) {
		return <PageNotAccessibleIfLoggedIn />
	}

	if (isSuccess && emailAddress) {
		return <SendEmailConfirmationSuccess emailAddress={emailAddress} onRetry={handleRetry} />;
	}

	return (
		<div className="row">
			<div className="col-12 offset-sm-2 col-sm-6" id="forgot_password_form_el">
				<div className="row">
					<div className="col-12 mb-4 text-left">
						<div className="header mb-2">Send Confirm Registration Email</div>
						<div className="sub-header">Supply your email to begin with.</div>
					</div>
					<div className="col-12 text-left mb-3">
						Recently registered and not received confirm registration email yet? Enter your email to get another one.
					</div>
					<div className="col-12">
						<FoundationsForm id="send_form" submitFunction={onSubmit} handleSubmit={handleSubmit}>
							<div id="status_message" className="col-12">
								{statusMessage && (
									<div className="status-box-error mb-3 text-left">
										{parse(statusMessage)}
									</div>
								)}
								{" "}
							</div>

							<div className="col-12">
								<FoundationsInput
									value={emailAddress}
									onInput={(e: { target: { value: string } }) => {
										const newEmail = e.target?.value;
										setEmailAddress(newEmail);
										if (!newEmail.trim()) {
											setStatusMessage(null);
										}
									}}
									id="email_input_el"
									name="email"
									classes="form-group row"
									labelText="Email:"
									labelClasses="col-12 col-sm-12 col-md-3 col-xl-3 text-left col-form-label"
									inputClasses="contact-inputs col-xl-8"
									containerClasses="col-11 col-sm-11 col-md-6 col-xl-8 float-right"
									registerFunction={register}
									registerName="EmailAddress"
									registerRules={FormValidation.sendEmail}
									error={errors.EmailAddress?.message}
									errorStyle={{ position: "absolute" }}
								/>
							</div>

							<div className="col-12 text-left mt-2 ml-2" style={{ paddingTop: '20px' }}>
								<FoundationsButton
									type="submit"
									id="send_button_el"
									buttonClasses="app-button on_key_press_enter"
									isLoading={isLoading}
									loaderClasses="app-account-loading w-90 d-block"
									classes="offset-md-3 col-4 text-left pl-0"
								>
									Send Email
								</FoundationsButton>
							</div>
						</FoundationsForm>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SendEmailConfirmation;
